export const todaydeals = [
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31FADBaOJ+L._AC_SY200_.jpg",
        discount: 78,
        Dealofday: "Deal of the day",
        desc: "Headsts Mania Deals"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/410iWt8d79L._AC_SY200_.jpg",
        discount: 60,
        Dealofday: "Deal of the day",
        desc: "Best Deal on Samsung S20 5G"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31cQxf0GUeL._AC_SY200_.jpg",
        discount: 72,
        Dealofday: "Deal of the day",
        desc: "Branded Suitcase,Backpacks and Duffle bags"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31nXVvSk7GL._AC_SY200_.jpg",
        discount: 76,
        Dealofday: "Deal of the day",
        desc: "Bestselling JBL True Wireless Earbuds"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31YahxzrgWL._AC_SY200_.jpg",
        discount: 47,
        Dealofday: "Deal of the day",
        desc: "Best Offers from V-Guard Water Purifier"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31FADBaOJ+L._AC_SY200_.jpg",
        discount: 78,
        Dealofday: "Deal of the day",
        desc: "Headsts Mania Deals"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/410iWt8d79L._AC_SY200_.jpg",
        discount: 60,
        Dealofday: "Deal of the day",
        desc: "Best Deal on Samsung S20 5G"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31cQxf0GUeL._AC_SY200_.jpg",
        discount: 72,
        Dealofday: "Deal of the day",
        desc: "Branded Suitcase,Backpacks and Duffle bags"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31FADBaOJ+L._AC_SY200_.jpg",
        discount: 78,
        Dealofday: "Deal of the day",
        desc: "Headsts Mania Deals"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/410iWt8d79L._AC_SY200_.jpg",
        discount: 60,
        Dealofday: "Deal of the day",
        desc: "Best Deal on Samsung S20 5G"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31cQxf0GUeL._AC_SY200_.jpg",
        discount: 72,
        Dealofday: "Deal of the day",
        desc: "Branded Suitcase,Backpacks and Duffle bags"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31nXVvSk7GL._AC_SY200_.jpg",
        discount: 76,
        Dealofday: "Deal of the day",
        desc: "Bestselling JBL True Wireless Earbuds"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/31YahxzrgWL._AC_SY200_.jpg",
        discount: 47,
        Dealofday: "Deal of the day",
        desc: "Best Offers from V-Guard Water Purifier"

    },
    {
        img: "https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/91R5ZVI5s8L._AC_SY200_.jpg",
        discount: 49,
        Dealofday: "Deal of the day",
        desc: "Top deals on PUMA,Skechers,Reebok"

    },
]